<template >
  <div >
    <div @contextmenu.prevent="handleExtras" >
      <div v-for="(grouping_choiceT, grouping_choice) in choice_labels" >


        <!--                {{ grouping_choice }}-->
        <el-button
            v-if="grouping_choiceT!='Route'&&isVisible(grouping_choice)"
            :title="grouping_choiceT"
            :key="grouping_choice"
            tabindex="-1"
            :class="['treeNode_groupingInfo_group',( groupData.groupings[grouping_choice].length == 1?'one_choice':'expanded'),
                          // {
                          //   one_choice:
                          //     groupData.groupings[grouping_choice].length == 1,
                          //      expanded:
                          //     groupData.groupings[grouping_choice].length > 1,
                          // },
                        ]"

            @click="$emit('expand-group',grouping_choice)" >

          <span
              class="treeNode_groupingInfo_group_label"
              v-for="(group, index) in groupData.groupings[
                            grouping_choice
                          ]"
              :key="index" >

            <span
                v-if="grouping_choice === 'for_trip'"
                :title="group.label"
                style="display: inline-block"
                :class="flights[group.label]&&flights[group.label].strip_tripType !== 'DEP'?'color_land':'color_takeoff'" >
              <strong ><small >{{ group.label }}</small >
                {{
                  formatUnxTime(
                      flights[group.label].strip_time,
                      true
                  )
                }}
              </strong >
              <span
                  v-if="flights[group.label]&&
                                flights[group.label].strip_tripType === 'DEP'
                              "

                  style="font-size: 16px !important" >
                              <i class="material-icons" >flight_takeoff</i >
                            </span >
               <span
                   v-else-if="flights[group.label]&&flights[group.label].strip_tripType === 'EXCRS'" style="font-size: 16px !important" >
                              <i class="material-icons" >kayaking</i >
                            </span >
              <span
                  v-else
                  class="color_land"
                  style="font-size: 16px !important" >
                              <i class="material-icons" >flight_land</i >
                            </span >
            </span >
            <strong
                v-else-if="grouping_choice === 'loc_code'"
                :title="locs[group.label].name" >{{ group.label }}
            </strong >
            <strong v-else >{{ group.label }}</strong >
            <span class="pax-tag" >{{ group.pax }}</span >
          </span >
        </el-button >

      </div >
      <q-card v-if="showCtxMenu" >
        <div
            class="row no-wrap q-pa-md"
            style="padding: 5px" >
          <div class="column" >
            <div class="text-h6 text-center bg-primary text-white text-small" >Route tools</div >
            <q-btn @click="showCtxMenu=false;$emit('routeAction',{action:'force-sort',node:node})" flat size="sm" >Resort Route
            </q-btn >
            <q-btn @click="showCtxMenu=false;$emit('routeAction',{action:'force-booked-time',node:node})" flat size="sm"  >Time Ticket->Driver
            </q-btn >

          </div >
        </div >
      </q-card >
    </div >
  </div >
</template >
<script >
export default {
  name: 'TripExpander',
  // mounted() {
  //   _log_('datagroupData',this.groupData)
  // },
  data() {
    return {
      showCtxMenu: false
    }
  },
  props: {
    stay: {type: Boolean, default: false},
    choice_labels: {},
    groupData: {},
    flights: {},
    grouping_choice: {},
    locs: {},
    node: {}
  },
  methods: {
    handleExtras($event) {
      if (this.stay !== false)
        this.showCtxMenu = !this.showCtxMenu
      _log_('context....menu', $event, this.groupData)
    },

    isVisible(grouping_choice) {
      // _log_('node',this.node)
      if (this.stay !== false) return true
      if (this.node.expanded) return false//&& this.node.childNodes[0] && this.node.childNodes[0].expanded) return false;//
      // _log_('this.groupData.group_by_name == grouping_choice', this.groupData.group_by_name, grouping_choice, this.node)
      const _grouping_choice = grouping_choice == 'loc_code' || grouping_choice == "pp_name" ? 'locations' : grouping_choice,
          _node_grouping_choice = this.groupData.group_by_name == 'loc_code' || this.groupData.group_by_name == "pp_name" ? 'locations' : this.groupData.group_by_name
      if (this.node.expanded && _node_grouping_choice == _grouping_choice) return false
      if (this.groupData.groupings && this.groupData.groupings[grouping_choice])
        return (this.groupData.groupings[grouping_choice].length == 1) || (
            this.groupData.groupings[grouping_choice].length > 1 &&
            (grouping_choice !== "pp_name" ||
                ((this.groupData.group_by_parent === "loc_code" ||
                        this.groupData.groupings["loc_code"] == null ||
                        this.groupData.groupings["loc_code"].length == 1) &&
                    grouping_choice === "pp_name"))
        );
    }
  }
}
</script >
<style >
.dark
.one_choice, .one_choice:hover, .one_choice:active {
  background: #2a5c69;
  border: none;
}

.dark
.one_choice .treeNode_groupingInfo_group_label {
  color: white;
  border: none;
}

.sunny .one_choice:hover, .sunny .one_choice:active {
  background: #dcca9e;
  border: none;
}

.bookings_tree .el-button {
  font-size: 12px;
  padding: 2px;
  border: none;
}

.bookings_tree .el-button.expanded {
  box-shadow: 0px 0px 1px;
}

/*.sunny*/
/*.one_choice{*/
/*  */
/*}*/
.sunny
.one_choice .treeNode_groupingInfo_group_label {
  color: #2a5c69;
}

.sunny
button.one_choice {
  background: none;
}

/*.expanded .treeNode_groupingInfo_group_label {*/
/*  border: 1px solid #0a4e47;*/
/*}*/

.bookings_composer_search_form form {
  display: flex;
  flex-wrap: wrap;
}

.bookings_composer_search_form * {
  display: inline-block;
}

@media (min-width: 500px) {

}

@media (max-width: 500px) {

}

.dark
.color_land {
  color: #c3c3f8 !important;
  /*background-color: #0a4e47;*/
}

.dark
.color_takeoff {
  /*background: #f5deb3;*/
  color: #ffe432;
}

.sunny
.one_choice .color_takeoff {
  color: #9f0030;
  /*border: red 1px solid;*/

}

.sunny
.color_land {
  color: #006435 !important;
  /*background-color: #0a4e47;*/
}

.sunny
.color_takeoff {
  /*background: #f5deb3;*/
  color: #9f0030;
}

.dark
.one_choice .color_takeoff {
  color: #ffe432;
  /*border: red 1px solid;*/

}

.treeNode_sort_button * {
  margin: 0;
}

.treeNode_paste_button * {
  margin: 0;
}

.treeNode_groupingInfo_group {
  padding-top: 10px;
  margin-right: 2px;
  max-width: 50vw;
  float: left;
  min-height: 26px;
  /*max-width: 50%;*/
  white-space: normal;

}

.treeNode_groupingInfo_group_label {
  display: inline-block;
  margin: 0;

  padding-right: 2px;
  font-size: 12px;
  white-space: normal;
}

.dark
.treeNode_groupingInfo_group_label {
  color: #f1eaea;
}

.sunny
.treeNode_groupingInfo_group_label {
  color: #2a5c69;
}

.treeNode_groupingInfo_group_label i.material-icons {
  font-size: 14px;
}

div.treeNode_info button:first-of-type {
  background: #fff;
  border-color: #409eff;
  color: #409eff;
}

.pax-tag {
  /*box-shadow: 0px 0px 1px;*/
  padding: 1px;
  margin: 2px;
  background: #eadbcb;
  color: #012126;
  border-radius: 2px;
}

.dark button.el-button.el-button--default {
  background-color: #0a4e47;
  color: wheat;
}

/* Element Classes */

/* Quasar Classes */

.q-table th,
.q-table td {
  padding: 4px 6px;
}

/* Others */
</style >
